class SubProductModal {
  constructor(el) {
    this.el = el;
    this.isOpen = false;

    this.bindUI();
    this.init();
    this.bindEvents();
  }

  bindUI() {
    this.openTriggers = document.querySelectorAll(`[data-modal-target='${this.el.id}']`);
    this.closeButton = this.el.querySelector('.js-subproduct-close-modal');
    this.content = this.el.querySelector('.js-subproduct-modal__content');
    this.backdrop = this.el.querySelector('.js-subproduct-modal__backdrop');
  }

  init() {
    this.timeline = gsap.timeline({
      paused: true,
      onStart: () => {
        this.el.classList.add('flex');
        this.el.classList.remove('hidden');
        this.stopScroll(true);
      },
      onReverseComplete: () => {
        this.el.classList.add('hidden');
        this.el.classList.remove('flex');
        this.stopScroll(false);
      },
      onComplete: () => {
        this.stopScroll(true);
      },
    });

    this.timeline.from(this.content, {
      opacity: 0,
      y: 16,
      duration: 0.5,
      ease: 'power2.inOut',
    }, "start");

    this.timeline.from(this.backdrop, {
      opacity: 0,
      duration: 0.5,
      ease: 'power2.inOut',
    }, "start");
  }

  bindEvents() {
    this.openTriggers.forEach(trigger => {
      trigger.addEventListener('click', () => this.open());
    });

    this.closeButton.addEventListener('click', () => this.close());

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      if (this.isOpen) this.close();
    });
  }

  stopScroll(stop) {
    document.body.style.overflow = stop ? 'hidden' : '';
  }

  open() {
    if (this.isOpen) return;

    this.el.classList.add('flex');
    this.el.classList.remove('hidden');
    this.stopScroll(true);
    this.isOpen = true;

    this.timeline.play();
  }

  close() {
    if (!this.isOpen) return;
    this.timeline.reverse();
    this.isOpen = false;
  }
}

function initSubProductModals() {
  document.querySelectorAll('.js-subproduct-modal').forEach(el => {
    new SubProductModal(el);
  });
}

document.addEventListener('DOMContentLoaded', initSubProductModals);


